<template>
  <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 bigBoxStyle">
    <skeleton-screen v-if="!dataLoaded"></skeleton-screen>
    <div v-if="dataLoaded" class="mb-2 d-flex justify-content-between pcxians align-items-center">
      <div class="sjjkdax" v-if="show == 0" style="font-size: calc(10px + 0.4vw);font-weight: 600;">{{ $t('物品捐款列表') }}</div>
      <div class="pl-0 pr-0 position-relative d-flex justify-content-between align-items-center">
        <div class="pl-0 pr-0 position-relative d-flex mr-3 align-items-center sjbsrkkd yuanjiao">
          <input v-model="keywords" @input="searchFn" class="form-control sxbj inppt pr-5 sjbxzt" type="text" :placeholder="this.$t('搜寻')" plaintext="true" aria-label="Username" aria-describedby="basic-addon1" />
          <img @click="searchFn" style="right: 20px; width: calc(10px + 0.4vw)" class="position-absolute curpo sbxfbd" src="@/img/daohangl/icon_hssy_sousuo@2x.png" alt="" />
        </div>
        <div @click="cjsj()" :style="{background:sxiajt == 1 ? '#FFEBD2':sxiajt == 2 ? '#FFEBD2':'#E5E5E5'}" class="pl-3 pr-3 pt-2 pb-2 d-flex align-items-center curpo yuanjiao" style="font-size: calc(7px + 0.4vw);">
          <div class="mr-2" style="font-size: calc(6px + 0.4vw)">{{ $t("创建时间") }}</div>
          <img v-if="sxiajt==1" style="width: calc(10px + 0.4vw);height: calc(10px + 0.4vw);" src="@/img/icon_sx_shang@2x (1).png" alt="">
          <img v-if="sxiajt==2" style="width: calc(10px + 0.4vw);height: calc(10px + 0.4vw);" src="@/img/icon_sx_shang@2x (2).png" alt="">
          <img v-if="sxiajt!=2 && sxiajt!=1" style="width: calc(10px + 0.4vw);height: calc(10px + 0.4vw);" src="@/img/icon_sx_shang@2x (2).png" alt="">
        </div>
        <div class="pl-0 pr-0 position-relative ml-3">
          <div class="d-flex ckqbb zhankai pl-3 pr-3 pt-2 pb-2 yuanjiao" type="button" id="dropdownMenuButtonm" @click="toggleDropdownm">
            <div class="d-flex align-items-center">
              <div class="sjbxzt" style="
                        font-size: calc(6px + 0.4vw);
                        margin-right: calc(5px + 0.5vw);
                      ">
                {{ tdjhuxaText }}
              </div>
              <img style="width: calc(7px + 0.4vw)" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
            </div>
          </div>
          <div class="dropdown-menu yuanjiao xlcd position-absolute lieb" aria-labelledby="dropdownMenuButtonm" v-show="istoggleDropdownm" style="border-radius: 7px; background: #fffaf0;max-height: 200px;overflow-y: auto;">
            <div class="dropdown-item sjbxzt yuanjiao mb-2" :style="{
                    background: tdjhuxa == item.id ? '#FFD672' : '',
                  }" @click="tdxuanz(item.id, item.name)" href="#" v-for="item, index in typeList" :key="index">{{
                    item.name }}</div>

          </div>
        </div>
      </div>
    </div>
    <div v-if="dataLoaded" class="mb-2 sjixians">
      <div class="d-flex justify-content-between align-items-center mt-3">
        <div class="sjjkdax" v-if="show == 0" style="font-size: calc(8px + 0.4vw);font-weight: 600;">{{ $t('物品捐款列表') }}</div>
        <div class="d-flex">
          <div @click="cjsj()" :style="{background:sxiajt == 1 ? '#FFEBD2':sxiajt == 2 ? '#FFEBD2':'#E5E5E5'}" class="pl-2 pr-2 pt-2 pb-2 d-flex align-items-center curpo yuanjiao" style="font-size: calc(7px + 0.4vw);">
            <div class="mr-2 sjbxzt">{{ $t("创建时间") }}</div>
            <img v-if="sxiajt==1" style="width: calc(10px + 0.4vw);height: calc(10px + 0.4vw);" src="@/img/icon_sx_shang@2x (1).png" alt="">
            <img v-if="sxiajt==2" style="width: calc(10px + 0.4vw);height: calc(10px + 0.4vw);" src="@/img/icon_sx_shang@2x (2).png" alt="">
            <img v-if="sxiajt!=2 && sxiajt!=1" style="width: calc(10px + 0.4vw);height: calc(10px + 0.4vw);" src="@/img/icon_sx_shang@2x (2).png" alt="">
          </div>
          <div class="pl-0 pr-0 position-relative ml-3">
            <div class="d-flex ckqbb zhankai pl-3 pr-3 pt-2 pb-2 yuanjiao" type="button" id="dropdownMenuButtonm" @click="toggleDropdownm">
              <div class="d-flex align-items-center">
                <div class="sjbxzt" style="
                        font-size: calc(6px + 0.4vw);
                        margin-right: calc(5px + 0.5vw);
                      ">
                  {{ tdjhuxaText }}
                </div>
                <img style="width: calc(7px + 0.4vw)" src="@/img/daohangl/icon_xlcd_xljt@2x (1).png" alt="" />
              </div>
            </div>
            <div class="dropdown-menu yuanjiao xlcd position-absolute lieb" aria-labelledby="dropdownMenuButtonm" v-show="istoggleDropdownm" style="border-radius: 7px; background: #fffaf0;max-height: 200px;overflow-y: auto;">
              <div class="dropdown-item sjbxzt yuanjiao mb-2" :style="{
                    background: tdjhuxa == item.id ? '#FFD672' : '',
                  }" @click="tdxuanz(item.id, item.name)" href="#" v-for="item, index in typeList" :key="index">{{
                    item.name?item.name : '' }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-3 mb-3" style="position: relative;">
        <div class="pl-0 pr-0 position-relative d-flex  align-items-center sjbsrkkd yuanjiao" style="width: 100%;">
          <input v-model="keywords" @input="searchFn" class="form-control sxbj inppt pr-5 sjbxzt" type="text" :placeholder="this.$t('搜寻')" plaintext="true" aria-label="Username" aria-describedby="basic-addon1" />
          <img @click="searchFn" style="right: 20px; width: calc(10px + 0.4vw)" class="position-absolute curpo sbxfbd" src="@/img/daohangl/icon_hssy_sousuo@2x.png" alt="" />
        </div>
      </div>
    </div>
    <div v-if="dataLoaded" class="col-md-12 pl-0 pr-0">
      <div v-if="show == 0" class="yinc col-md-12 pl-0 pr-0">
        <div class="col-md-12 pl-0 pr-0  d-flex pl-0 pr-0 ">
          <div class="col-md-12 pl-0 pr-0">
            <div class="mt-1 d-flex lieb" style="flex-wrap: wrap;gap: 1%;width: 100%;background: #F6F4F0;border-radius: 14px;justify-content: space-around;padding: 1%;">
              <div class="sjliebkd" style="width: 32%;" v-for="(item, index) in items" :key="index">
                <div class="col-sm-12 baise mb-3 ckqbb p-3 yuanjiao pl-0 pr-0 curpo" style="width: 100%;text-align: center;">
                  <img v-if="item.goods_img[0]" @click="fun(1, item.id)" class="yuanjiao" style="width: 100%;height:calc(210px + 0.4vw);object-fit: cover;" :src="item.goods_img[0].img_url.url" alt="" />
                  <img v-else @click="fun(1, item.id)" class="yuanjiao" style="width: 100%;height:calc(210px + 0.4vw);object-fit: cover;" src="" alt="" />
                  <div @click="fun(1, item.id)" class="mt-3 mb-3 text-left" style="font-size: calc(8px + 0.4vw);font-weight: 700;"><span>{{ item.name?item.name:'' }}</span> </div>
                  <div @click="fun(1, item.id)" class="col-sm-12 d-flex justify-content-between pl-0 pr-0" style="width: 100%;">
                    <div class="col-sm-4 text-center pl-0 pr-0" style="font-size: calc(5px + 0.4vw);">
                      <div style="color: #999999;">{{ $t('剩餘數量') }}</div>
                      <div style="font-weight: 500;">{{ item.surplus_number ? item.surplus_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                    </div>
                    <div class="col-sm-4 text-center pl-0 pr-0" style="font-size: calc(5px + 0.4vw);">
                      <div style="color: #999999;">{{ $t('物資類別') }}</div>
                      <div style="font-weight: 500;">{{ item.goods_type.name ?item.goods_type.name :'' }}</div>
                    </div>
                    <div class="col-sm-4 text-center pl-0 pr-0" style="font-size: calc(5px + 0.4vw);">
                      <div style="color: #999999;">{{ $t('物資所在地') }}</div>
                      <div style="font-weight: 500;">{{ item.goods_position ? item.goods_position : '-' }}</div>
                    </div>
                  </div>
                  <div @click="fun(1, item.id)" class="pl-3 pr-3 pt-2 pb-2 d-flex justify-content-between align-items-center yuanjiao mb-2 mt-3" style="font-size: calc(6px + 0.4vw);background: #FFFAF0;">
                    <div style="color: #666666;min-width: 30%;text-align: left;">{{ $t('捐贈團體') }}</div>
                    <div class="ellipsis" style="font-weight: 600;">{{ item.organization.name ? item.organization.name : '-' }}</div>
                  </div>
                  <div @click="fun(1, item.id)" class="pl-3 pr-3 pt-2 pb-2 d-flex justify-content-between align-items-center yuanjiao mb-3" style="font-size: calc(6px + 0.4vw);background: #FFFAF0;">
                    <div style="color: #666666;">{{ $t('碳积分') }}</div>
                    <div style="font-weight: 600;">{{ item.carbon_coin ? item.carbon_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                  </div>
                  <div class="col-sm-12 pl-0 pr-0 d-flex justify-content-between mt-3 align-items-center">
            
                    <div @click="fun(1, item.id)" class="col-sm-12 pl-0 pr-0 ckqbb yuanjiao pt-2 pb-2" style="background-color: #FFEAB8;text-align: center;font-size: calc(7px + 0.4vw);">
                      {{ $t('查看详情') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="d-flex justify-content-center" style="margin: auto">
                <div v-if="items.length == 0" style="margin-bottom: 10vh;">
                  <empty></empty>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 手机 -->
      <div v-if="show == 0" class="aaaa" style="width: 100%;">
        <div class="lieb mt-0" style="display: flex;flex-wrap: wrap;gap: 1%;width: 100%;">
          <div style="width: 100%;" v-for="(items, index) in items " :key="index">
            <div class="col-sm-12 baise mb-3 ckqbb p-3 yuanjiao pl-0 pr-0 curpo" style="width: 100%;text-align: center;">
              <img v-if="items.goods_img[0]" @click="fun(1, items.id)" class="yuanjiao" style="width: 100%;height:calc(210px + 0.4vw);object-fit: cover;" :src="items.goods_img[0].img_url.url" alt="" />
              <img v-else @click="fun(1, items.id)" class="yuanjiao" style="width: 100%;height:calc(210px + 0.4vw);object-fit: cover;" src="" alt="" />
              <div @click="fun(1, items.id)" class="mt-3 sjbzt text-left mb-3" style="font-size: calc(8px + 0.4vw);font-weight: 700;"><span>{{ items.name }}</span> </div>
              <div @click="fun(1, items.id)" class="col-sm-12 d-flex justify-content-between pl-0 pr-0" style="width: 100%;">
                <div class="col-sm-4 text-center pl-0 pr-0 sjbxzt" style="font-size: calc(5px + 0.4vw);">
                  <div class="mb-1" style="color: #999999;">{{ $t('剩餘數量') }}</div>
                  <div style="font-weight: 500;">{{ items.surplus_number ? items.surplus_number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
                </div>
                <div class="col-sm-4 text-center pl-0 pr-0 sjbxzt" style="font-size: calc(5px + 0.4vw);">
                  <div class="mb-1" style="color: #999999;">{{ $t('物資類別') }}</div>
                  <div style="font-weight: 500;">{{ items.goods_type.name  }}</div>
                </div>
                <div class="col-sm-4 text-center pl-0 pr-0 sjbxzt" style="font-size: calc(5px + 0.4vw);">
                  <div class="mb-1" style="color: #999999;">{{ $t('物資所在地') }}</div>
                  <div style="font-weight: 500;">{{ items.goods_position ? items.goods_position : '-' }}</div>
                </div>
              </div>
              <div @click="fun(1, items.id)" class="pl-3 sjbzt pr-3 pt-2 pb-2 d-flex justify-content-between align-items-center yuanjiao mb-2 mt-3" style="font-size: calc(6px + 0.4vw);background: #FFEBD2;">
                <div style="color: #666666;min-width: 30%;text-align: left;">{{ $t('捐贈團體') }}</div>
                <div class="ellipsis" style="font-weight: 600;">{{ items.organization.name ? items.organization.name : '-' }}</div>
              </div>
              <div @click="fun(1, items.id)" class="pl-3 sjbzt pr-3 pt-2 pb-2 d-flex justify-content-between align-items-center yuanjiao mb-3" style="font-size: calc(6px + 0.4vw);background: #FFEBD2;">
                <div style="color: #666666;">{{ $t('碳积分') }}</div>
                <div style="font-weight: 600;">{{ items.carbon_coin ? items.carbon_coin.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0' }}</div>
              </div>
              <div class="col-sm-12 pl-0 pr-0 d-flex justify-content-between mt-3 align-items-center">
              
                <div @click="fun(1, items.id)" class="col-sm-12 sjbzt pl-0 pr-0 ckqbb yuanjiao pt-2 pb-2" style="background-color: #FFEAB8;text-align: center;font-size: calc(7px + 0.4vw);">
                  {{ $t('查看详情') }}
                </div>
              </div>
            </div>

          </div>
          <div class="d-flex justify-content-center" style="margin: auto">
            <div v-if="items.length == 0" style="margin-bottom: 10vh;">
              <empty></empty>
            </div>
          </div>
        </div>

      </div>
    </div>
    <router-view />
    <juank v-if="show == 3" :isid="idds" @custom='custom'></juank>
  </div>
</template>
  
  <script>
import { EventBus } from "@/views/event-bus.js";
import { goods_list, goods_type_list } from "@/request/aapi.js";
import { formatTimestamp } from "@/utils/common.js";
import SkeletonScreen from "./SkeletonScreen/xinSkeletonScreen.vue";
//   import juank from "./wmuc/juank.vue";
import empty from "@/components/empty/empty.vue";
import router from "@/router";
export default {
  components: {
    SkeletonScreen,
    empty,
    //   juank,
  },
  data() {
    return {
      jinnwaxs: false,
      jhuxa: this.$t("请选择排序类型"),
      isDropdownOpen: false,
      keywords: "",
      selected: "",
      dataLoaded: false,
      show: 0,
      sxiajt: "",
      currentIndex: 0,
      progress: 60,
      items: [],
      idss: null,
      isT: null,
      idds: null,
      currentPage: 1,
      tdjhuxaText: this.$t("物資類別"),
      tdjhuxa: "",
      istoggleDropdownm: false,
      typeList: [],
    };
  },
  props: {
    ids: {
      type: Number,
      default: null,
    },
  },

  created() {
    this.updateVisibleItems();
    this.getRegister_category();
  },
  beforeDestroy() {},
  mounted() {},
  computed: {},
  methods: {
    toggleDropdownm() {
      this.istoggleDropdownm = !this.istoggleDropdownm;
      this.isDropdownOpen = false;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    getRegister_category() {
      goods_type_list({
        type: 2,
      }).then((res) => {
        // console.log(res, '团体类型')
        this.typeList = res.data;
      });
    },
    tdxuanz(e, n) {
      this.tdjhuxa = e;
      this.tdjhuxaText = n;
      this.istoggleDropdownm = false;
      this.items = [];
      this.currentPage = 1;
      this.updateVisibleItems();
    },
    timeFilter(stringTime) {
      return formatTimestamp(stringTime * 1000);
    },
    cjsj() {
      let b = this.sxiajt == 2 ? 1 : this.sxiajt == 1 ? 2 : 2;
      this.sxiajt = b;
      let a =
        this.sxiajt == 1
          ? "create_time_asc"
          : this.sxiajt == 2
          ? "create_time_desc"
          : "create_time_desc";
      this.selected = a;
      this.items = [];
      this.currentPage = 1;
      this.updateVisibleItems();
    },
    zjyt() {
      let b = this.sxiajt == 6 ? 5 : this.sxiajt == 5 ? 6 : 6;
      this.sxiajt = b;
      let a =
        this.sxiajt == 5
          ? "used_amount_asc"
          : this.sxiajt == 6
          ? "used_amount_desc"
          : "used_amount_desc";
      this.selected = a;
      this.items = [];
      this.currentPage = 1;
      this.updateVisibleItems();
    },
    cyrs() {
      let b = this.sxiajt == 8 ? 7 : this.sxiajt == 7 ? 8 : 8;
      this.sxiajt = b;
      let a =
        this.sxiajt == 7
          ? "donor_num_asc"
          : this.sxiajt == 8
          ? "donor_num_desc"
          : "donor_num_desc";
      this.selected = a;
      this.items = [];
      this.currentPage = 1;
      this.updateVisibleItems();
    },
    // 搜寻
    searchFn() {
      this.items = [];
      this.currentPage = 1;
      this.updateVisibleItems();
    },
    toggleDropdown() {
      this.isDropdownOpen = !this.isDropdownOpen;
      // 如果需要，可以在这里添加Bootstrap Dropdown的额外处理逻辑
    },
    gundong() {
      console.log(123);
      if (this.currentPage < this.last_page) {
        this.currentPage += 1;
        this.updateVisibleItems();
      }
    },

    updateVisibleItems() {
      // 计算当前应该显示的列表项索引范围
      const data = {
        page: this.currentPage,
        date: this.sxiajt,
        name: this.keywords,
      };
      goods_list(data).then((res) => {
        if (res.code == 200) {
          this.dataLoaded = true;
        }
        this.last_page = res.data.last_page;
        this.totalPages = res.data.total;
        if (this.totalPages == 0) {
          this.ishow = true;
        } else {
          this.ishow = false;
        }
        this.items = [...this.items, ...res.data.data];
      });
    },
    // 查看全部跳转
    emsl() {
      this.$emit("emslfun", 1);
      // this.$refs..getInfo()
    },
    smdckxq(e) {
      this.fun(1, e);
    },
    fun(e, a) {
      this.$router.push({
        path: "claim/item/" + a,
      });
    },
  },
};
</script>
  
  <style scoped lang="scss">
@media screen and (max-width: 1200px) {
  .sjliebkd {
    width: 49% !important;
  }
  .sjyinc {
    display: block !important;
  }
  .bigBoxStyle{
    width:100%!important;
    background-color: #F6F4F0!important;
  }
}
@media screen and (max-width: 995px) {
  .sjjkdax {
    font-size: calc(13px + 0.4vw) !important;
  }
  .sjixians {
    display: block !important;
  }
  .pcxians {
    display: none !important;
  }
}
@media screen and (max-width: 750px) {
  .sjbzt {
    font-size: calc(14px + 0.4vw) !important;
  }
  .sjbxzt {
    font-size: calc(11px + 0.4vw) !important;
  }
  .sjbxxzt {
    font-size: calc(9px + 0.4vw) !important;
  }
  .aaaa {
    display: block !important;
  }
  .yinc {
    display: none !important;
  }
}
.bigBoxStyle{
  background: #fff;
  border-radius: 24px;
  padding: 1vh 1vw;
  margin-top: 1vh;
  width: calc( 100% - 20vw )
}
.sjixians {
  display: none;
}
.aaaa {
  display: none;
}
.sjyinc {
  display: none;
}
.sxbj {
  padding-top: calc(15px + 0.5vw);
  padding-bottom: calc(15px + 0.5vw);
}
.form-control {
  height: calc(15px + 0.5vw) !important;
}
.ckqbb:hover {
  transform: scale(1.001);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.inppt {
  background: white;
  border: none;
  border-radius: 13px;
  font-size: calc(7px + 0.4vw);
}
.dcbd:hover {
  transform: scale(1.2);
  /* 悬浮时放大1.1倍 */
  // padding: 12px;
}
.lieb::-webkit-scrollbar {
  display: none;
}
.jdtt {
  height: 100%;
  background: #fab1ab;
  color: #1a1a1a;
  text-align: right;
  font-size: calc(6px + 0.4vw);
}

.fangda:hover {
  transform: scale(1.02);
}

.dydpd {
  padding-top: calc(7px + 0.4vw);
  padding-bottom: calc(7px + 0.4vw);
  padding-left: calc(10px + 0.5vw);
  padding-right: calc(10px + 0.5vw);
}

.xlcd {
  display: block;
  background: #ffebd2;
  border: none;
}

.xuazz:hover {
  background: #ffebd2;
}
.dropdown-menu {
  min-width: calc(25px + 0.5vw) !important;
  font-size: calc(8px + 0.4vw) !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  // left: -1rem;
}
.zhankai {
  background: #ffebd2;
  text-align: center;
  border: none;
  font-weight: 400;
  font-size: calc(6px + 0.4vw);
  color: #1a1a1a;
}

.parent::-webkit-scrollbar {
  display: none;
}

.dropdown-item:hover {
  background-color: #ffebd2;
  color: #b66d00;
  border-radius: 12px;
}

.dropdown-item {
  width: calc(100px + 0.4vw);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.dropdown-item{
  text-align: left;
}

.custom-pagination ::v-deep .page-item.active .page-link {
  background-color: rgb(255, 214, 114);
  border-color: rgb(255, 214, 114);
  color: #000;
}
.lieb::-webkit-scrollbar {
  display: none;
}
</style>